/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckOperator } from './PaxCheckOperator';
import {
    PaxCheckOperatorFromJSON,
    PaxCheckOperatorFromJSONTyped,
    PaxCheckOperatorToJSON,
    PaxCheckOperatorToJSONTyped,
} from './PaxCheckOperator';

/**
 * Checklist item requirement: compare field value ({field} {operator} {value}, eg expiryDate >= 2025-10-25)
 * @export
 * @interface PaxCheckFieldCompare
 */
export interface PaxCheckFieldCompare {
    /**
     * Requirement represented as text
     * @type {string}
     * @memberof PaxCheckFieldCompare
     */
    asText: string;
    /**
     * Field
     * @type {string}
     * @memberof PaxCheckFieldCompare
     */
    field: string;
    /**
     * 
     * @type {PaxCheckOperator}
     * @memberof PaxCheckFieldCompare
     */
    operator: PaxCheckOperator;
    /**
     * Value of the field to compare with - type depends on field
     * @type {string}
     * @memberof PaxCheckFieldCompare
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckFieldCompare
     */
    type: string;
}



/**
 * Check if a given object implements the PaxCheckFieldCompare interface.
 */
export function instanceOfPaxCheckFieldCompare(value: object): value is PaxCheckFieldCompare {
    if (!('asText' in value) || value['asText'] === undefined) return false;
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('operator' in value) || value['operator'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckFieldCompareFromJSON(json: any): PaxCheckFieldCompare {
    return PaxCheckFieldCompareFromJSONTyped(json, false);
}

export function PaxCheckFieldCompareFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckFieldCompare {
    if (json == null) {
        return json;
    }
    return {
        
        'asText': json['as_text'],
        'field': json['field'],
        'operator': PaxCheckOperatorFromJSON(json['operator']),
        'value': json['value'],
        'type': json['type'],
    };
}

export function PaxCheckFieldCompareToJSON(json: any): PaxCheckFieldCompare {
    return PaxCheckFieldCompareToJSONTyped(json, false);
}

export function PaxCheckFieldCompareToJSONTyped(value?: PaxCheckFieldCompare | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'as_text': value['asText'],
        'field': value['field'],
        'operator': PaxCheckOperatorToJSON(value['operator']),
        'value': value['value'],
        'type': value['type'],
    };
}

